
export const hasError = (dataObj) => {
    if(dataObj.error){
        return true;
    } else {
        return false;
    }
}

export const getRandNum = () => {
    let randInt = Math.floor(Math.random() * 10);
    return randInt
}

export const getRandAction = () => {
    let actionOptions = ['-', '*', '+'];
    let randIndex =
        Math.floor( Math.random() * ((actionOptions.length - 1) - 0 + 1) + 0);
    let randExpression = actionOptions[randIndex];

    return randExpression;
}

export const evalString = (expressionType, intA, intb) => {
    let solution = null;

    switch(expressionType){
        case '-': solution = intA - intb;            
            break;

        case '*': solution = intA * intb;
            break;   

        case '+': solution = intA + intb;
            break;

        default: break;

    }

    return solution;

}